export const PageIndex = 1;
export const PageSizes = {
  DEFAULT: 20,
  DIALOG: 10,
} as const;
